import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withRouter } from '../../utils/withRouter';
import Loader from '../../utils/Loader'
import { clearSessionStorage } from '../../utils/constants'
import Header from '../../common_components/Header';
import { emailValidator } from '../../utils/Validator'
import Modal from "react-modal";
import Footerwithdr from '../../common_components/Footerwithdr';
import HeaderWithLogo from '../../common_components/header_with_logo';
import AdminDrawer from '../../common_components/admin_module_drawer';
import { fill_action } from '../../actions/fillCombo_action'
import { Link } from "react-router-dom";
import { getAdminDashboardData_action } from "../../actions/admin_module_action/admin_dasboard_action/admin_dashboard_action"
import VendorDrawer from '../../common_components/vendor_module_drawer';
import StallPossessionChecklistList from '../admin_module/stall_possession_checklist/stall_possession_checklist_list';
import WorkUpdation from './work_updation';
import DailyRoutineTaskList from '../admin_module/daily_routine_task/daily_routine_task_list';
import HMExitPassList from "../hallManager_module/hall_manager_exit_pass";
import VendorTaskDetail from '../vendor_module/vendor_task/vendor_task_detail';
import VendorExhibitionList from '../vendor_module/vendor_exhibition_list/vendor_exhibition_list';
import AccountExitPassList from '../admin_module/accountExitPass/accountExitPass';

class HallManager extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            summaryPage: sessionStorage.getItem("summaryPage") ? sessionStorage.getItem("summaryPage") : JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 20 ? 'workUpdation' : 'stallPossessionChecklistList',
            // Input Fields
            pendingPaymentCount: "",
            loginAccesslist: [],
            isTeamMember: JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 20
        }
        this.toNavigate = this.toNavigate.bind(this)
    }

    toNavigate() {
        const { summaryPage } = this.state
        if (summaryPage == 'stallPossessionChecklistList') {
            return <StallPossessionChecklistList />
        }
        if (summaryPage == 'workUpdation') {
            return <WorkUpdation />
        }
        if (summaryPage == 'hmExitPassList') {
            // return <HMExitPassList />
            return <AccountExitPassList />
        }
        if (summaryPage == 'dailyRoutineTaskList') {
            return <DailyRoutineTaskList />
        }
        if (summaryPage == 'vendorTaskDetail') {
            return <VendorTaskDetail />
        }
        if (summaryPage == 'vendorExhibitionList') {
            return <VendorExhibitionList />
        }
    }

    render() {
        const { isLoading, pendingPaymentCount, summaryPage, isTeamMember } = this.state
        return (
            <>

                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}

                <ToastContainer />
                <HeaderWithLogo />
                {/* <ExhibitorDrawer /> */}
                <>
                    {/* <AdminDrawer /> */}
                    {/*app-content open*/}
                    <div className="onsite-manager-wrapper" style={{ marginLeft: 0 }} >
                        <div className="mt-0">
                            <ul className="nav nav-pills tab-scroll-fixed">
                                {!isTeamMember &&
                                    <li onClick={() => this.setState({ summaryPage: 'stallPossessionChecklistList' }, () => {
                                        sessionStorage.setItem("summaryPage", "stallPossessionChecklistList")
                                    })} className="nav-item ">
                                        {" "}
                                        <a className={summaryPage == 'stallPossessionChecklistList' ? "nav-link active px-4 py-2" : "nav-link  px-4 py-2"}>
                                            Stall Possession{" "}
                                        </a>{" "}
                                    </li>
                                }
                                <li onClick={() => this.setState({ summaryPage: 'workUpdation' }, () => {
                                    sessionStorage.setItem("summaryPage", "workUpdation")
                                })} className="nav-item ">
                                    {" "}
                                    <a className={summaryPage == 'workUpdation' ? "nav-link active px-4 py-2" : "nav-link  px-4 py-2"}>
                                        Order{" "}
                                    </a>{" "}
                                </li>
                                {!isTeamMember &&
                                    <li onClick={() => this.setState({ summaryPage: 'hmExitPassList' }, () => {
                                        sessionStorage.setItem("summaryPage", "hmExitPassList")
                                    })} className="nav-item ">
                                        {" "}
                                        <a className={summaryPage == 'hmExitPassList' ? "nav-link active px-4 py-2" : "nav-link  px-4 py-2"}>
                                            Material Exit pass{" "}
                                        </a>{" "}
                                    </li>
                                }
                                <li onClick={() => this.setState({ summaryPage: 'dailyRoutineTaskList' }, () => {
                                    sessionStorage.setItem("summaryPage", "dailyRoutineTaskList")
                                })} className="nav-item ">
                                    {" "}
                                    <a className={summaryPage == 'dailyRoutineTaskList' ? "nav-link active px-4 py-2" : "nav-link  px-4 py-2"}>
                                        Routine Task{" "}
                                    </a>{" "}
                                </li>
                                <li onClick={() => this.setState({ summaryPage: 'vendorTaskDetail' }, () => {
                                    sessionStorage.setItem("summaryPage", "vendorTaskDetail")
                                })} className="nav-item ">
                                    {" "}
                                    <a className={summaryPage == 'vendorTaskDetail' ? "nav-link active px-4 py-2" : "nav-link  px-4 py-2"}>
                                        Service Partner Task{" "}
                                    </a>{" "}
                                </li>
                                {/* {isTeamMember &&
                                    <li onClick={() => this.setState({ summaryPage: 'vendorExhibitionList', subPage: null }, () => {
                                        sessionStorage.setItem("summaryPage", "vendorExhibitionList")
                                    })} className="nav-item ">
                                        <a className={summaryPage == 'vendorExhibitionList' ? "nav-link active px-4 py-2" : "nav-link  px-3 py-2"}>
                                            Order
                                        </a>
                                    </li>
                                } */}
                            </ul>
                        </div>
                        {this.toNavigate()}
                    </div>
                    {/* <VendorDrawer /> */}
                </>
                <div className="" style={{ position: 'fixed', bottom: '0px', width: '100%', zIndex: 99 }}>
                    <div className='footer-out-with-dr m-0 mt-2'>
                        <div className="footer-sec">
                            <strong>Ownership:</strong> All content, formats and images used on this site are owned or licensed by India ITME Society. You may not copy, reproduce, distribute, publish, display, perform, modify, create derivative works, transmit, or in any other way exploit any part of copyrighted material without permission of the copyright owner. Failure to comply shall result in legal action.
                        </div>
                        <div className="footer-first">
                            ITME All Rights Reserved <i class="fa fa-copyright"></i> 2023
                        </div>
                    </div>
                </div>

            </>
        );
    }


}

export default withRouter(connect(null, { getAdminDashboardData_action })(HallManager));
